import en from './en.json';
import fo from './fo.json';

const storageKey = 'dystir.language';
const supported = ['fo', 'en'];

export function getLanguage() {
    // Embedded partner pages retain their existing Faroese presentation.
    if (/^\/(info|portal|roysni|fm1)(\/|$)/i.test(window.location.pathname)) return 'fo';
    const requested = new URLSearchParams(window.location.search).get('lang');
    if (supported.includes(requested)) return requested;
    try {
        const saved = window.localStorage.getItem(storageKey);
        if (supported.includes(saved)) return saved;
    } catch { /* Storage can be unavailable in private or embedded browsers. */ }
    return 'fo';
}

export function t(key) {
    return ({ fo, en }[getLanguage()][key]) ?? en[key] ?? key;
}

export function setLanguage(language) {
    if (!supported.includes(language) || language === getLanguage()) return;
    try { window.localStorage.setItem(storageKey, language); } catch { }
    // Reload also updates labels held in the legacy singleton service and page state.
    const url = new URL(window.location.href);
    url.searchParams.set('lang', language);
    window.location.assign(url.toString());
}

document.documentElement.lang = getLanguage();
